import { render } from "./PBarPoint.vue?vue&type=template&id=73b0308a&scoped=true"
import script from "./PBarPoint.vue?vue&type=script&lang=js"
export * from "./PBarPoint.vue?vue&type=script&lang=js"

import "./PBarPoint.vue?vue&type=style&index=0&id=73b0308a&lang=sass&scoped=true"

import exportComponent from "D:\\Open Server 5.3.5\\OSPanel\\domains\\front\\personal_form\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b0308a"]])

export default __exports__